import { render, staticRenderFns } from "./BoxTypesChip.vue?vue&type=template&id=1f8414d4&"
import script from "./BoxTypesChip.vue?vue&type=script&lang=js&"
export * from "./BoxTypesChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports